import axios from "axios";
import React, { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import BasicTenderInfo from "../../Users/BriefTender/BasicTenderInfo";
import Step1 from "./Step1";
import Step2 from "./Step2";
import Preview from "./Preview";

const BidSubmission = () => {
  const [bid, setBid] = useState();
  const [tender, setTender] = useState();
  const [workItems, setWorkItems] = useState();
  const [step, setStep] = useState(1);
  const storedUser = JSON.parse(localStorage.getItem("user"));
  const vendorId = JSON.parse(localStorage.getItem("vendor"));
  const { tenderId } = useParams();
  const location = useLocation();
  const [fileNames, setFileNames] = useState({
    ts1: "",
    ts2: "",
    ts3: "",
    ts4: "",
    ts5: "",
    ts6: "",
    ts7: "",
    ts8: "",
  });

  useEffect(() => {
    const getTender = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/tender/get-by-id?tenderId=${tenderId}`,
          { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
        );
        setTender(res.data);
        setWorkItems(res.data.workItemDetails.map((item) => ({ ...item, rate: 0, total: 0 })));
        if (res.data.isSingleBid) {
          setStep(2)
        }
      } catch (error) {
        console.error(error);
      }
    };
    getTender();
  }, []);

  useEffect(() => {
    if(location.pathname.includes("/draft")){
      const getBid = async () => {
        try {
          const res = await axios.get(
            `${process.env.REACT_APP_BACKEND_URL}/draft-bid?vendorId=${vendorId}&tenderId=${tenderId}`,
            { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
          );
          setBid(res.data);
          if(res.data.draftBidWorkItems && res.data.draftBidWorkItems.length > 0){
            setWorkItems(res.data.draftBidWorkItems);
          }
          setFileNames({
            ts1: res.data.ts1Filename,
            ts2: res.data.ts2Filename,
            ts3: res.data.ts3Filename,
            ts4: res.data.ts4Filename,
            ts5: res.data.ts5Filename,
            ts6: res.data.ts6Filename,
            ts7: res.data.ts7Filename,
            ts8: res.data.ts8Filename,
          })
        } catch (error) {
          console.error(error);
        }
      };
      getBid();
    }
  }, [])
  return (
    <div>
      {tender && (
        <div>
          <BasicTenderInfo tender={tender} />
          {step === 1 && (
            <Step1
              tender={tender}
              setStep={setStep}
              bid={bid}
              setBid={setBid}
              storedUser={storedUser}
              fileNames={fileNames}
              setFileNames={setFileNames}
            />
          )}
          {step === 2 && (
            <Step2
              tender={tender}
              data={workItems}
              setData={setWorkItems}
              setStep={setStep}
              user={storedUser}
              bid={bid}
            />
          )}
          {step === 3 && (
            <Preview
              tender={tender}
              setStep={setStep}
              bid={bid}
              data={workItems}
              user={storedUser}
              fileNames={fileNames}
            />
          )}
        </div>
      )}
    </div>
  );
};

export default BidSubmission;
